import React, { Component } from 'react';
import { Button, Image, ButtonToolbar, Label } from 'react-bootstrap';
import EntitiesList from '../../common/components/EntitiesList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';

class List extends Component {
	renderButtonsCell(paymentMethod, onEnable, onDisable, onConfigure, t, isReadonly) {
		const isEnabled = paymentMethod.isConfigurationEnabled;
		return (
			<div>
				<ButtonToolbar>
					<Button bsStyle='primary' style={{ marginBottom: '10px' }} disabled={paymentMethod.isReadOnly} onClick={() => onConfigure(paymentMethod)}>
						<FontAwesomeIcon icon={faCog} /> {t('PaymentMethod_Configure')}
					</Button>
					{/*isEnabled ? <Button bsStyle='danger' disabled={isReadonly} onClick={() => onDisable(paymentMethod)}><FontAwesome name='stop-circle' /> {t('Common_Disable')}</Button> :
					<Button bsStyle='success' disabled={isReadonly} onClick={() => onEnable(paymentMethod)}><FontAwesome name='play-circle' /> {t('Common_Enable')}</Button>
				*/}
				</ButtonToolbar>
			</div>
		);
	}

	renderDescriptionCell(paymentMethod, t) {
		return (
			<div >
				<strong>{paymentMethod.fullName} </strong>
				<Label bsStyle={paymentMethod.isConfigurationEnabled ? 'success' : 'danger'}>{t(paymentMethod.isConfigurationEnabled ? 'PaymentMethod_Enabled_True' : 'PaymentMethod_Enabled_False')}</Label>
				<br />
				{paymentMethod.description}
			</div>
		);
	}

	render() {
		const { isReadonly, t, onEnable, onDisable, onConfigure, ...rest } = this.props;
		const columns = [
			{
				accessor: 'logoFilename',
				cell: (logoFilename) => (<Image src={require(`../../../theme/images/payment/${logoFilename}`)} responsive style={{ maxWidth: '200px' }} />),
			},
			{
				accessor: 'id',
				cell: (id, row) => this.renderDescriptionCell(row, t)
			},
			{
				accessor: 'id',
				cell: (id, row) => this.renderButtonsCell(row, onEnable, onDisable, onConfigure, t, isReadonly)
			}
		];

		return (
			<EntitiesList columns={columns} {...rest} />
		);
	}
}

export default List;